import { render, staticRenderFns } from "./Heading.vue?vue&type=template&id=c72efc3a"
import script from "./Heading.vue?vue&type=script&lang=js"
export * from "./Heading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pforret/Code/Movix/laravel/showtimes.movix/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c72efc3a')) {
      api.createRecord('c72efc3a', component.options)
    } else {
      api.reload('c72efc3a', component.options)
    }
    module.hot.accept("./Heading.vue?vue&type=template&id=c72efc3a", function () {
      api.rerender('c72efc3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/partials/Heading.vue"
export default component.exports